import { initialValidations } from "_common/ssrWrapper";
import { getResults }         from "_components/pages/game/cardListData/container";
import Component              from "_components/pages/gamingVideos";

function GamingVideos ( props ) {
	return (
		<Component
			popupVideo = { true }
			{ ...props }
		/>
	);
}

const getServerSideProps = async context => initialValidations ( context, async ( defaultProps, context ) => {

	const gameId = 2052989, androidPackageName = "GamingWorldDesktop", name = "gaming-world";

	const results = await Promise.allSettled (
		[
			getResults.bind ( defaultProps ) ( { searchQuery: name, key: "videos", pageNo: 1, gameId, androidPackageName } )
		]
	);

	let response;
	let forceLogout = false;

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					response = result.value;
					break;
			}
		}

		if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			forceLogout = true;
	} );

	if ( forceLogout )
		return {
			redirect: {
				destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
				permanent   : false
			}
		};

	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  ); */

	return {
		props: {
			...defaultProps,
			name,
			androidPackageName,
			gameId,
			feedList: response
		}
	};
} );

export { getServerSideProps };

export default GamingVideos;
